var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPokemonTypeIconBug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#90c12c;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bug"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,40c-3.93,9.55-11.51,12.15-21,13-5.9,17.33.62,36.47,13,49C104.88,90.71,109.26,57,89,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.43,45.31A22.08,22.08,0,0,0,83,36a38.15,38.15,0,0,0-8.24-3.3l5.56-6.8a3,3,0,0,0-4.64-3.8l-7.55,9.23a31.72,31.72,0,0,0-8.26,0L52.32,22.1a3,3,0,1,0-4.64,3.8l5.56,6.8A38.15,38.15,0,0,0,45,36,22.12,22.12,0,0,0,72.43,45.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,50a23,23,0,0,1-8-10c-1,.87-15.43,13.39-13,33,2.46,19.85,19.86,28.46,21,29C59.38,89.47,65.9,70.33,60,53,57.93,52.82,51.49,53.14,47,50Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokemonTypeIconBug);
export default __webpack_public_path__ + "static/media/Pokemon_Type_Icon_Bug.235aa1af24bef819709e033ea65fe71f.svg";
export { ForwardRef as ReactComponent };